import * as React from "react";
import { useContext, useState, useEffect } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { ServiceContext } from "src/services/provider/Service.provider";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { createEmptyTradeOwner } from "src/services/interfaces/trade/tradeOwner/ITradeOwner";
import { Col, Row, Spin, notification } from "antd";
import { PbrCard } from "src/components/common/PbrCard/PbrCard";
import StandardButton from "src/components/common/StandardButton/StandardButton";
import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import { needMarriageCertificate, userHaveSpouse } from "src/util/Validations";
import Form, { FormComponentProps } from "antd/lib/form";

import "./ManualTradeEditContainer.scss";
import { validateForm } from 'src/util/helper';
import { TradeEditView } from 'src/components/common/TradeEdit/TradeEditView';
import { DocumentCategoryLabel, DocumentCategoryEnum } from 'src/components/Refatoracao/UploadDocument/DocumentCategoryEnum';

function ManualTradeEditContainer(props: RouteComponentProps<any> & FormComponentProps) {
  const { tradeService, documentService } = useContext(ServiceContext);
  const [loading, setLoading] = useState(false);

  const [trade, setTrade] = useState<ITrade>(undefined);

  useEffect(() => {
    GetTradeById(props.match.params.id);
  }, []);

  const GetTradeById = (id: number) => {
    setLoading(true);
    tradeService
      .getById(id)
      .then(resp => {
        if (!resp.tradeOwner) {
          resp.tradeOwner = createEmptyTradeOwner();
        }
        setTrade(resp);
      })
      .catch(ex => ShowNotification.Error("Não foi possivel buscar o trade", "Tente novamente mais tarde"))
      .finally(() => setLoading(false));
  };

  async function UpdateTrade() {
    if (validateForm(props) && await validateUpdate()) {
      setLoading(true);
      tradeService.postUpdateManualTrade(trade, true)
        .then(() => {
          ShowNotification.Success("Sucesso!", "Dados do trade alterado com sucesso");
        })
        .catch(err => {
          notification.error({
            description: err?.response?.data?.message ?? "Não foi possível salvar os dados informados.",
            message: "Erro ao salvar as informações "
          })
        })
        .finally(() => setLoading(false));
    }
  }

  async function validateUpdate() {
    if (userHaveSpouse(trade)) {
      const document = await documentService.getSpouseDocIdByTradeId(trade.id);
      if (!document) {
        ShowNotification.Error("Não é possivel avançar o trade", "Documento do Conjuge é obrigatório");
        return false;
      }
    }

    if (needMarriageCertificate(trade)) {
      const document = await documentService.getMarriageCertificateByTradeId(trade.id);

      if (!document) {
        ShowNotification.Error("Não é possivel avançar o trade", "Documento de Casamento é obrigatório");
        return false;
      }
    }

    const addressDocument = await documentService.getDocumentByTradeAndCategory(trade.id, DocumentCategoryEnum.PROOF_OF_RESIDENCE);

    if (!addressDocument) {
      ShowNotification.Error("Não é possivel avançar o trade", `${DocumentCategoryLabel.get(DocumentCategoryEnum.PROOF_OF_RESIDENCE)} é obrigatório`);
      return false;
    }

    return true;
  }

  return (
    <Form>

      <div className="trade-info">
        {trade && (
          <PbrCard title={`Editando Trade ${trade.id}`} bordered={false}>
            <Spin spinning={loading} tip="Carregando">
              <TradeEditView
                loading={loading}
                setLoading={setLoading}
                trade={trade}
                setTrade={setTrade}
                form={props.form}
                showBankInfo
                isMotherNameRequired
                isCivilStatusRequired
                isProfessionRequired
                isTradeSpouseRequired
              />
            </Spin>
            <Row gutter={16} className="actions-btn-row" style={{ marginTop: "20px" }}>
              <Col sm={24} md={12} lg={12} xl={12} style={{ textAlign: "right" }}>
                <StandardButton preset="outline" onClick={() => props.history.goBack()}>
                  Voltar
                </StandardButton>
              </Col>
              <Col sm={24} md={12} lg={12} xl={12}>
                <StandardButton onClick={e => UpdateTrade()} loading={loading}>
                  Salvar
                </StandardButton>
              </Col>
            </Row>
          </PbrCard>
        )}
      </div>
    </Form>
  );
}

export default withRouter(Form.create()(ManualTradeEditContainer));



// WEBPACK FOOTER //
// ./src/pages/monitor/edit/manual-trade/ManualTradeEditContainer.tsx